// ---------------------------------------------------------------------------
// Block Definition: section_header
//
// Chrome label that sits above a column/band.  Pure layout — no data extraction.
// ---------------------------------------------------------------------------

const EVIDENCE_DESC = "Verbatim sentence(s) from the SOURCE that justify this value — quote exactly, do not paraphrase.";

function nullable(type, description, extra = {}) {
  const t = Array.isArray(type) ? type : [type, "null"];
  return { type: t, ...(description ? { description } : {}), ...extra };
}

export const sectionHeaderDef = {
  type: "section_header",
  label: "Section Header",
  description: "Small uppercase label above a column or band.",

  crystallizer: null,

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "heading",
    category: "layout",
    defaultTemplate: { type: "section_header", text: "New Section" },
    configFields: [
      { name: "text", type: "string", label: "Label text", required: true },
    ],
  },
};
